module.exports = __webpack_public_path__ + "img/6b6972309457fa8b92c63f20c86c1ac6.55230943.jpg";